/**
 * First we will load all of this project"s JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@babel/polyfill";

window.Vue = require("vue");

Vue.use(Vuetify);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context("./", true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split("/").pop().split(".")[0], files(key).default));

Vue.component("global-nav", require("./components/GlobalNav.vue").default);
Vue.component("post", require("./components/Post.vue").default);
Vue.component("feature", require("./components/Feature.vue").default);
Vue.component("report", require("./components/Report.vue").default);
Vue.component("post-feature", require("./components/PostFeature.vue").default);
Vue.component("tags", require("./components/Tags.vue").default);
Vue.component(
    "global-footer",
    require("./components/GlobalFooter.vue").default,
);
Vue.component("user-header", require("./components/UserHeader.vue").default);
Vue.component("loading", require("./components/Loading.vue").default);
Vue.component("search-tabs", require("./components/SearchTabs.vue").default);
Vue.component(
    "phone-country-select",
    require("./components/PhoneCountrySelect.vue").default,
);
Vue.component("contact-form", require("./components/ContactForm.vue").default);
Vue.component(
    "name-input-form",
    require("./components/NameInputForm.vue").default,
);
Vue.component(
    "kana-input-form",
    require("./components/KanaInputForm.vue").default,
);
Vue.component("seminar-tabs", require("./components/SeminarTabs.vue").default);
Vue.component(
    "seminar-tabs-tag",
    require("./components/SeminarTabsTag.vue").default,
);
Vue.component("seminar", require("./components/Seminar.vue").default);
Vue.component(
    "seminar-payment",
    require("./components/SeminarPayment.vue").default,
);
Vue.component(
    "seminar-invoice",
    require("./components/SeminarInvoice.vue").default,
);
Vue.component(
    "seminar-address",
    require("./components/SeminarAddress.vue").default,
);
Vue.component(
    "seminar-report",
    require("./components/SeminarReport.vue").default,
);
Vue.component(
    "seminar-payment-btn",
    require("./components/SeminarPaymentBtn.vue").default,
);

Vue.component("post-body", require("./components/PostBody.vue").default);
Vue.component("form-select", require("./components/FormSelect.vue").default);

Vue.component("snack-bar", require("./components/SnackBar.vue").default);

Vue.component(
    "stripe-subscription",
    require("./components/StripeSubscription.vue").default,
);
Vue.component(
    "personal-plan-form",
    require("./components/PersonalPlanForm.vue").default,
);

// 退会画面
Vue.component("unregister", require("./components/Unregister.vue").default);
Vue.component("free-reason", require("./components/FreeReason.vue").default);

Vue.component("user-image", require("./components/UserImage.vue").default);

Vue.component(
    "order-report-list",
    require("./components/OrderReportList.vue").default,
);

Vue.component("plan-select", require("./components/PlanSelect.vue").default);
Vue.component(
    "corporate-plan-select",
    require("./components/CorporatePlanSelect.vue").default,
);

Vue.component(
    "corpolate-plan-submit",
    require("./components/CorpolatePlanSubmit.vue").default,
);
Vue.component(
    "customer-portal-link",
    require("./components/CustomerPortalLink.vue").default,
);
Vue.component(
    "lb-subsc-customer-portal-link",
    require("./components/LbSubscCustomerPortalLink.vue").default,
);
Vue.component(
    "premium-member-switch-admin",
    require("./components/mypage/SwitchAdminForPremiumMember.vue").default,
);
Vue.component(
    "premium-member-cancel-delete",
    require("./components/mypage/DeleteChildForPremiumMember.vue").default,
);
Vue.component(
    "lb-order-switch-admin",
    require("./components/mypage/SwitchAdminForLbOrder.vue").default,
);
Vue.component(
    "lb-order-change-admin",
    require("./components/mypage/ChangeAdminForLborder.vue").default,
);
Vue.component(
    "lb-subscription-switch-admin",
    require("./components/mypage/SwitchAdminForLbSubscription.vue").default,
);
Vue.component(
    "lb-subscription-change-admin",
    require("./components/mypage/ChangeAdminForLbSubscription.vue").default,
);
Vue.component(
    "lb-subscription-cancel-child",
    require("./components/mypage/CancelChildForLbSubscription.vue").default,
);
Vue.component(
    "lb-subscription-cancel-all",
    require("./components/mypage/CancelAllForLbSubscription.vue").default,
);

Vue.component(
    "personal-plan-step",
    require("./components/PersonalPlanStep.vue").default,
);
Vue.component(
    "corpolate-plan-step",
    require("./components/CorpolatePlanStep.vue").default,
);

Vue.component(
    "fintech-search",
    require("./components/FintechSearch.vue").default,
);
Vue.component(
    "fintech-categories",
    require("./components/FintechCategories.vue").default,
);
Vue.component(
    "fintech-initial",
    require("./components/FintechInitial.vue").default,
);
Vue.component(
    "fintech-data-row",
    require("./components/FintechDataRow.vue").default,
);
Vue.component(
    "fintech-info-row",
    require("./components/FintechInfoRow.vue").default,
);
Vue.component("fintech-sort", require("./components/FintechSort.vue").default);
Vue.component(
    "fintech-sort-asc",
    require("./components/FintechSortAsc.vue").default,
);
Vue.component("fintech", require("./components/Fintech.vue").default);
Vue.component(
    "fintech-block",
    require("./components/FintechBlock.vue").default,
);
Vue.component("fintech-body", require("./components/FintechBody.vue").default);

Vue.component(
    "lb-plan-select",
    require("./components/LbPlanSelect.vue").default,
);
Vue.component(
    "lb-personal-plan-form",
    require("./components/LbPersonalPlanForm.vue").default,
);
Vue.component(
    "lb-corpolate-plan-submit",
    require("./components/LbCorpolatePlanSubmit.vue").default,
);
Vue.component(
    "lb-corpolate-plan-step",
    require("./components/LbCorpolatePlanStep.vue").default,
);
Vue.component(
    "lb-corpolate-btn",
    require("./components/LbCorpolateBtn.vue").default,
);
Vue.component(
    "lb-checkout-select",
    require("./components/LbCheckoutSelect.vue").default,
);
Vue.component(
    "learning-start-date-picker",
    require("./components/LearningStartDatePicker.vue").default,
);

Vue.component(
    "lb-personal-subsc-plan-form",
    require("./components/LbPersonalSubscPlanForm.vue").default,
);
Vue.component(
    "lb-corpolate-subsc-plan-submit",
    require("./components/LbCorpolateSubscPlanSubmit.vue").default,
);

Vue.component("register", require("./components/Register.vue").default);
Vue.component(
    "password-login-form",
    require("./components/password/LoginForm.vue").default,
);
Vue.component(
    "password-mypage-form",
    require("./components/password/MypageForm.vue").default,
);

Vue.component("popup-invite", require("./components/PopupInvite.vue").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app",
    data: {
        learning_months: "",
        payment_method: "",
    },
    mounted() {
        const initialLearningMonths = document.getElementById(
            "initial_learning_months",
        );
        if (initialLearningMonths) {
            this.learning_months = Number(initialLearningMonths.value);
        }
        const initialPaymentMethod = document.getElementById(
            "initial_payment_method",
        );
        if (initialPaymentMethod) {
            this.payment_method = initialPaymentMethod.value;
        }
    },
});

export default {
    data() {
        return {
            locale:
                "{{ isset($__loggedInUser->locale) && $__loggedInUser->locale !== '' ? $__loggedInUser->locale : 'ja' }}",
        };
    },
};
